export function agentOptionLabel(profile) {
  if (!profile) return "";
  if (profile.name) return profile.name;
  const fullName = [profile.firstName, profile.lastName].filter(Boolean).join(" ");
  if (fullName) return fullName;
  return profile.username || String(profile.id ?? "");
}

export function mapAgentProfile(profile) {
  return {
    ...profile,
    id: profile?.id,
  };
}
